import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HelpCircle, AlertOctagon, Puzzle, FileSearch, Sparkles, LayoutGrid, Undo2, UserCheck, Loader2 } from "lucide-react";
import { streamJoe } from "../../lib/api";

const BTNS = [
  ["why", "Why are you asking this?", HelpCircle], ["wrong", "That information is wrong", AlertOctagon],
  ["dont_understand", "I don't understand", Puzzle], ["doc", "Check my document", FileSearch], ["simple", "Explain this simply", Sparkles],
  ["options", "Show my options", LayoutGrid], ["change", "Change my answer", Undo2], ["specialist", "Talk to a specialist", UserCheck],
];

export const JoeHelper = ({ q, onBack }) => {
  const nav = useNavigate();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const ask = async (mode) => {
    setText("");
    setBusy(true);
    try {
      await streamJoe({ mode, question: q.q, message: q.why }, (t) => setText((p) => p + t));
    } catch (e) {
      setText("Joe couldn't answer right now. Please try again.");
    }
    setBusy(false);
  };

  const act = (k) => {
    if (k === "why") return setText(q.why);
    if (k === "wrong" || k === "change") return onBack(k);
    if (k === "doc") return nav("/case?tab=documents");
    if (k === "options") return nav("/case?tab=options");
    if (k === "specialist") return nav("/case?tab=specialist");
    ask(k);
  };

  return (
    <div className="no-print" data-testid="joe-helper">
      <p className="mb-2 font-mono text-[11px] uppercase tracking-widest text-slate-500">Joe, check that again</p>
      <div className="flex flex-wrap gap-2">
        {BTNS.map(([k, l, Icon]) => (
          <button key={k} type="button" data-testid={`helper-${k}`} onClick={() => act(k)}
            className="tap inline-flex items-center gap-1.5 rounded-full border border-slate-300 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:border-slate-900">
            <Icon className="h-3.5 w-3.5" /> {l}
          </button>
        ))}
      </div>
      {(text || busy) && (
        <div data-testid="joe-response" className="rise mt-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 text-[15px] leading-relaxed text-slate-800">
          <div className="mb-1 flex items-center gap-2 font-display text-base font-bold uppercase text-amber-800">
            <img src="/brand/joe-avatar.webp" alt="Joe" className="h-8 w-8 rounded-full border-2 border-brand-navy object-cover" /> Joe says {busy && <Loader2 className="h-3.5 w-3.5 animate-spin" />}
          </div>
          <p className="whitespace-pre-wrap">{text}</p>
        </div>
      )}
    </div>
  );
};
